import { fromJS } from 'immutable';
import { createSelector } from 'reselect';
import { ListCases } from '../../api/Cases';

// ACTIONS TYPES
export const LIST_CASES_SUCCESS = 'customer-portal/cases/LIST_CASES_SUCCESS';
export const LIST_CASES_FAILURE = 'customer-portal/cases/LIST_CASES_FAILURE';
export const FETCHING_CASES_LIST = 'customer-portal/cases/FETCHING_CASES_LIST';
export const RESET_CASES = 'customer-portal/cases/RESET_CASES';

// ACTION CREATORS
const listCasesSuccess = cases => ({
  type: LIST_CASES_SUCCESS,
  payload: cases,
});

const listCasesFailure = err => ({
  type: LIST_CASES_FAILURE,
  payload: err,
});

const fetchingCasesList = () => ({
  type: FETCHING_CASES_LIST,
});

export const resetCases = () => ({
  type: RESET_CASES,
});

// THUNKS
export const fetchCasesList = prospectId => async dispatch => {
  dispatch(fetchingCasesList());
  try {
    const { data } = await ListCases(prospectId);
    dispatch(listCasesSuccess({ data, prospectId }));
  } catch (error) {
    dispatch(listCasesFailure(error.message));
  }
};

export const shouldFetchCases = casesState => {
  if (casesState.get('loading') || casesState.get('loaded')) {
    return false;
  }
  return true;
};

export const fetchCasesIfNeeded = prospectId => (dispatch, getState) => {
  if (!shouldFetchCases(getState().cases)) {
    return null;
  }
  return dispatch(fetchCasesList(prospectId));
};

// SELECTORS
const casesSelector = state => state.cases;

export const getCases = createSelector([casesSelector], cases => {
  const allRecords = cases.get('records');
  if (allRecords.size > 0) {
    return allRecords.first().data.cases;
  }
  return null;
});

export const getCasesLoading = createSelector([casesSelector], cases => cases.get('loading') || !cases.get('loaded'));

// REDUCER
export const initialState = fromJS({
  loaded: false,
  loading: false,
  error: null,
  records: [],
});

export default (state = initialState, action) => {
  switch (action.type) {
    case LIST_CASES_SUCCESS:
      return state
        .set('loaded', true)
        .set('loading', false)
        .updateIn(['records'], arr => arr.push(action.payload));
    case LIST_CASES_FAILURE:
      return state.set('loading', false).set('loaded', true).set('error', action.payload);
    case FETCHING_CASES_LIST:
      return state.set('loading', true);
    case RESET_CASES:
      return initialState;
    default:
      return state;
  }
};
